export default {
    colors: {
      primary: "#3f51b5",
      secondary: "#D3D3D3",
      light: "#FFFFFF",
  
      texto: "#363F5F",
      
      darkGrey: "#808080",
      light2: "#969CB2",
  
      lightBluer: "#ADD8D6",
  
      success: "#12A454",
      attention: "#E83F5B",
    },
  
    fonts: {
      regular: "Poppins_400Regular",
      medium: "Poppins_500Medium",
      bold: "Poppins_700Bold",
    },
  };